import React, { useState, useEffect } from 'react';
import Footer from '../../Components/Footer/Footer';
import HomeNav from '../../Components/Navbar/NewNavbar';
import Loading1 from '../../Components/Loading/Loading1';
import { HiOutlineHand, HiOutlineLightBulb, HiOutlineShieldExclamation, HiOutlineChatAlt2, HiOutlineUserGroup, HiOutlineLockClosed } from 'react-icons/hi';

function CommunityGuidelines() {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 800);
        return () => clearTimeout(timer);
    }, []);

    if (isLoading) {
        return <Loading1 />;
    }

    const guidelines = [
        {
            icon: <HiOutlineHand size={24} />,
            title: "Mutual Respect",
            desc: "We foster an environment of professional excellence. Abusive language or discriminatory behavior toward our staff or clients is strictly prohibited."
        },
        {
            icon: <HiOutlineLightBulb size={24} />,
            title: "Responsible Use",
            desc: "Our premium services must be used for their intended clinical and hygiene purposes. Misleading information may lead to account suspension."
        },
        {
            icon: <HiOutlineShieldExclamation size={24} />,
            title: "Safe Environments",
            desc: "Clients must ensure service areas are safe and accessible. Any hazardous conditions should be communicated prior to specialist arrival."
        },
        {
            icon: <HiOutlineChatAlt2 size={24} />,
            title: "Clear Communication",
            desc: "Honest dialogue ensures quality. Provide accurate requirements during booking to help us match the right specialist to your needs."
        }
    ];

    return (
        <div className="bg-white min-h-screen">
            <HomeNav />
            
            {/* Guidelines Hero */}
            <section className="pt-40 pb-20 bg-secondary relative overflow-hidden text-center">
                <div className="container-custom relative z-10 mx-auto max-w-3xl px-4">
                    <span className="text-primary font-black uppercase tracking-[0.3em] text-xs">Community Etiquette</span>
                    <h1 className="text-5xl md:text-6xl font-heading font-black text-foreground mt-4">
                        United by <span className="text-primary italic">Respect</span>
                    </h1>
                    <p className="text-muted-foreground text-lg mt-6 leading-relaxed">
                        These guidelines ensure a harmonious experience for our clients and the cleaning specialists who keep your spaces immaculate.
                    </p>
                </div>
            </section>

            <section className="py-24">
                <div className="container-custom">
                    <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-10 max-w-5xl mx-auto">
                        {guidelines.map((item, i) => (
                            <div key={i} className="card-premium p-10 space-y-6 hover:shadow-2xl transition-all border-l-4 border-l-primary/20 hover:border-l-primary">
                                <div className="w-14 h-14 rounded-2xl bg-primary/5 text-primary flex items-center justify-center">
                                    {item.icon}
                                </div>
                                <h3 className="text-2xl font-black">{item.title}</h3>
                                <p className="text-muted-foreground leading-relaxed font-medium">
                                    {item.desc}
                                </p>
                            </div>
                        ))}
                    </div>

                    {/* Commitment Banner */}
                    <div className="mt-20 p-12 rounded-[3.5rem] bg-black text-white text-center space-y-6 overflow-hidden relative">
                        <div className="relative z-10 max-w-2xl mx-auto">
                            <h2 className="text-3xl font-heading font-black">Our Professional <span className="text-primary italic">Pact</span></h2>
                            <p className="text-gray-400 font-medium">
                                By engaging with AstraClean, you join a community built on transparency, safety, and hygiene excellence. We continuously strive to exceed these standards in every interaction.
                            </p>
                        </div>
                        {/* Decorative elements */}
                        <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-primary/20 rounded-full blur-3xl"></div>
                        <div className="absolute -top-10 -right-10 w-40 h-40 bg-primary/10 rounded-full blur-3xl"></div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
}

export default CommunityGuidelines;

